export const savingsCalculatorFormula = (initialDeposit, monthlyContribution, maturity, maturityDuration, apy) => {
    const monthsInYear = 12;
    const daysInYear = 365;
    const rate = apy / 100;
    const totalMonths = maturityDuration.value === 'YEARS' ? maturity * monthsInYear : maturity;
    const dailyInterestRate = Math.pow(1 + rate, 1 / daysInYear) - 1;
    const FVP = initialDeposit * Math.pow(1 + dailyInterestRate, (totalMonths / monthsInYear) * daysInYear);
    let FVM = 0;
    for (let n = 1; n <= totalMonths; n++) {
        FVM += monthlyContribution * Math.pow(1 + dailyInterestRate, ((totalMonths - n) / monthsInYear) * daysInYear);
    }
    const interestEarned = FVP + FVM - initialDeposit - monthlyContribution * totalMonths;
    const totalAmount = FVP + FVM;
    const additionalContribution = totalMonths * monthlyContribution;
    return {
        totalSavings: parseFloat(totalAmount.toFixed(2)),
        interestEarned: parseFloat(interestEarned.toFixed(2)),
        additionalContribution: parseFloat(additionalContribution.toFixed(2))
    };
};
